import React, { useEffect, useRef } from "react";
import '../home/home.css';
import bg from '../../assets/download.jpeg';
import vision from '../../assets/vision.jpg';
import mission from '../../assets/mission.png';
import Benifits from '../../assets/benifits.png';
import logo from '../../assets/acm-bg-logo.png'
import { Helmet } from "react-helmet";

<Helmet>
  <link href="https://fonts.googleapis.com/css?family=Teko:700&display=swap" rel="home.css" />
</Helmet>;



function Home() {

  const missionRef = useRef(null);
  const cursorRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.animationPlayState = "running";
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.75,
      }
    );
    const animatedElements = missionRef.current.querySelectorAll(
      ".mission-img, .mission-heading, .mission-line, .mission-describe"
    );

    animatedElements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();

  }, []);

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (cursorRef.current) {
        cursorRef.current.style.top = `${event.clientY}px`;
        cursorRef.current.style.left = `${event.clientX}px`;
      }
    };

    document.addEventListener("mousemove", handleMouseMove);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);


  return (
    <section >

      <div className='cursor' ref={cursorRef}></div>

      <div className='web-view'>
        <div className='image-bg'>
          <h2 className="bg-text">KARE</h2>
          
          <img src={bg} alt='bg' className='bg-img' />
          <h1 className="bg-text-p"><span class='one'>A</span><span class='two'>C</span><span class='three'>M</span><span class='four'>-</span><span class='five'>W</span></h1>
          <h2 className="bg-text"> Student Chapter</h2>
          <img src = {logo} alt = 'logo' className="acm-logo"/>
          
        </div>

        <div>
          <div className='About'>
            {/* <div className="line About-line"></div> */}
            <div className='heading'>
              <h2 className='about-heading'>
                <span>A</span><span>b</span><span>o</span><span>u</span><span>t</span> <span>U</span><span>s</span>
              </h2>
            </div>

            <div className='about-content'>
              <p className='about-describe'>ACM - W Student Chapter (Chapter ID : 180857) at KARE campus is aimed to serve as a gateway of forums, panel discussions and symposia that further a student’s proffesional development. Encouraging students to take an active interest in the emerging and exciting world of computing preparations and presentations of the technical reports and papers and cooperative efforts on research projects allow students to test their technical expertise. </p>
            </div>
          </div>
        </div>

        <div className='home-video'>
          <iframe className='yt-video' src="https://www.youtube.com/embed/xUmCqK5TxvU?si=qX_tlFYkQpJmjaln" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>

        <aside className="news-box">
          <h2>UPDATES</h2>
          <div>
            <div className="news-content">
              <p>Breaking News: Major Event Happens!</p>
              <p>Update: More Details About the Event.</p>
              <p>Exclusive: Interviews with Key Figures.</p>
              <p>Breaking News: Major Event Happens!</p>
              <p>Update: More Details About the Event.</p>
              <p>Exclusive: Interviews with Key Figures.</p>
              <p>Breaking News: Major Event Happens!</p>
              <p>Update: More Details About the Event.</p>
              <p>Exclusive: Interviews with Key Figures.</p>
            </div>
          </div>
        </aside>

        <div className="mission mission-animation-text" ref={missionRef}>
          <img
            className="mission-img"
            src={mission}
            alt="mission"
          />
          <div className="mission-line"></div>
          <div className="heading">
            <h2 className="mission-heading">Mission</h2>
          </div>
          <div className="mission-content">
            <p className="mission-describe">
              Our mission is to support, celebrate, and advocate
              internationally for the full engagement of women in all
              aspects of the computing field, provide a wide range of
              programs and services to ACM members and work in the larger
              community to advance the contributions of technical women.
            </p>
          </div>
        </div>

        <div className='vision vision-animation-text'>
          <img className='vision-img' src={vision} alt="vision" />
          <div className="vision-line"></div>
          <div className='heading'>
            <h2 className='vision-heading'>Vision</h2>
          </div>
          <div className='vision-content'>
            <p className='vision-describe'>Our vision is to inspire, support, and empower women in computing to achieve their fullest potential. We aim to create a vibrant, inclusive community where diversity is not just valued but actively championed. By providing mentorship, resources, and opportunities for growth, we seek to break down barriers, encourage innovation, and ensure that every woman's voice is heard and celebrated in the advancement of technology. Together, we envision a future where women lead and innovate, shaping the digital world for the betterment of society.</p>
          </div>
        </div>

        <div className='benefits benefits-animation-text'>
          <img className='benefits-img' src={Benifits} alt="Benifits" />
          <div className="benefits-line"></div>
          <div className='heading'>
            <h2 className='benefits-heading'>Benifits</h2>
          </div>
          <div className='benefits-content'>
            <p className='benefits-describe'>Our ACM-W chapter offers a wide range of benefits to its members, including access to a supportive network of women in computing, opportunities for professional development, and a platform to showcase your skills and achievements. Members gain valuable mentorship from industry leaders, participate in exclusive workshops and events, and receive guidance for career advancement. By being part of our chapter, you'll connect with like-minded individuals, stay updated on the latest trends in technology, and contribute to a community that is
              dedicated to fostering diversity and innovation in the tech world.</p>
          </div>
        </div>

      </div>

      <div className='mobile-view'>
        <div className='image-bg'>
          <img src={bg} alt='bg' className='bg-img' />
        </div>

        <div className='img-text'>
          <h2>KARE ACM - W STUDENT CHAPTER</h2>
        </div>

        <div>
          <div className='About'>
            {/* <div className="line About-line"></div> */}
            <div className='heading'>
              <h2 className='about-heading'>About Us</h2>
            </div>
            <div className='about-content'>
              <p className='about-describe'>ACM - W Student Chapter (Chapter ID : 180857) at KARE campus is aimed to serve as a gateway of forums, panel discussions and symposia that further a student’s proffesional development. Encouraging students to take an active interest in the emerging and exciting world of computing preparations and presentations of the technical reports and papers and cooperative efforts on research projects allow students to test their technical expertise. </p>
            </div>
          </div>
        </div>

        <div className="news-box">
          <h2>Upcoming</h2>
          <div>
            <div className="news-content">
              <p>Breaking News: Major Event Happens!</p>
              <p>Update: More Details About the Event.</p>
              <p>Exclusive: Interviews with Key Figures.</p>
              <p>Breaking News: Major Event Happens!</p>
              <p>Update: More Details About the Event.</p>
              <p>Exclusive: Interviews with Key Figures.</p>
              <p>Breaking News: Major Event Happens!</p>
              <p>Update: More Details About the Event.</p>
              <p>Exclusive: Interviews with Key Figures.</p>
            </div>
          </div>
        </div>

        <div className='home-video'>
          <iframe className='mobile-yt-video' src="https://www.youtube.com/embed/xUmCqK5TxvU?si=qX_tlFYkQpJmjaln" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>

        <div className="M-mission mission-animation-text">

          <div className="M-mission-line"></div>
          <div className="heading">
            <h2 className="M-mission-heading">Mission</h2>
          </div>
          <img
            className="M-mission-img"
            src={mission}
            alt="mission"
          />
          <div className="M-mission-content">
            <p className="M-mission-describe">
              Our mission is to support, celebrate, and advocate
              internationally for the full engagement of women in all
              aspects of the computing field, provide a wide range of
              programs and services to ACM members and work in the larger
              community to advance the contributions of technical women.
            </p>
          </div>
        </div>

        <div className='vision vision-animation-text'>
          <div className="vision-line"></div>
          <div className='heading'>
            <h2 className='vision-heading'>Vision</h2>
          </div>
          <img className='vision-img' src={vision} alt="vision" />
          <div className='vision-content'>
            <p className='vision-describe'>Our vision is to inspire, support, and empower women in computing to achieve their fullest potential. We aim to create a vibrant, inclusive community where diversity is not just valued but actively championed. By providing mentorship, resources, and opportunities for growth, we seek to break down barriers, encourage innovation, and ensure that every woman's voice is heard and celebrated in the advancement of technology. Together, we envision a future where women lead and innovate, shaping the digital world for the betterment of society.</p>
          </div>
        </div>

        <div className='benefits benefits-animation-text'>
          <div className="benefits-line"></div>
          <div className='heading'>
            <h2 className='benefits-heading'>Benifits</h2>
          </div>
          <img className='benefits-img' src={Benifits} alt="Benifits" />
          <div className='benefits-content'>
            <p className='benefits-describe'>Our ACM-W chapter offers a wide range of benefits to its members, including access to a supportive network of women in computing, opportunities for professional development, and a platform to showcase your skills and achievements. Members gain valuable mentorship from industry leaders, participate in exclusive workshops and events, and receive guidance for career advancement. By being part of our chapter, you'll connect with like-minded individuals, stay updated on the latest trends in technology, and contribute to a community that is
              dedicated to fostering diversity and innovation in the tech world.</p>
          </div>
        </div>
      </div>
    </section>


  );
}

export default Home;